import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CustomIcons } from '@shared/models/custom-icons';
import { TypeInfo } from '../../../../../models/catalog';

@Component({
  selector: 'app-download-dialog',
  templateUrl: './download-dialog.component.html',
  styleUrls: ['./download-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadDialogComponent {
  public icons = CustomIcons;
  public catalogId: string;
  public isDynamic: boolean;
  public filesTypes: TypeInfo[];
  public createFile: ($event: MouseEvent, file: TypeInfo) => void;
  public downloadFile: ($event: MouseEvent, file: TypeInfo) => void;
  public downloadPasport: (type: 'json' | 'csv') => void;
  public openHistoricalDataModal: () => void;
  constructor(private dialogRef: MatDialogRef<DownloadDialogComponent>, private cdr: ChangeDetectorRef) {}

  public update(): void {
    this.cdr.detectChanges();
  }
  public close(): void {
    this.dialogRef.close();
  }
}
